const PERMISSION_KEY= "crm:custom_field";
const PAGE_URL = {
    CUSTOM_FIELD_PAGE: "/admin/crm/custom-field"
}

export {PERMISSION_KEY, PAGE_URL}

